import classNames from 'classnames';

import { CtfBlockTextPositions, CtfBlockTextStyle } from '@/utils/constants';

// @TODO: move hardcoded space
export function getBlockWrapperClass({ blockAlignment, halfWidth, style, isBlockquote, alignBlockQuoteLeft, compactSpace, noMarginBottomMobile }) {
  return classNames(
    'aaco-block-text__wrapper',
    'flex flex-wrap w-full mx-auto',
    {
      'container mb-8': !compactSpace && !noMarginBottomMobile,
      'container mb-0 md:mb-8': !compactSpace && noMarginBottomMobile,
      'justify-end':
        halfWidth && blockAlignment === CtfBlockTextPositions.RIGHT,
      'justify-center block-quote-wrap': isBlockquote && !alignBlockQuoteLeft,
    },
    style
  );
}

// @TODO: move hardcoded space
export function getBlockClass({ noGap, halfWidth, style, isBlockquote, compactSpace }) {
  return classNames(
    'aaco-block-text grid',
    {
      'gap-y-4': !noGap,
      'w-full md:w-1/2': halfWidth,
      'lg:w-2/3 block-quote-text': isBlockquote && !compactSpace,
      'lg:w-full': compactSpace,
    },
    style
  );
}
